import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
// import { useHistory } from 'react-router-dom';

function useManageQuizQuestion(data = {}) {
  const { quizID, courseID, chapterID, configs = {} } = data ?? {};
  // const history = useHistory();
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addQuizQuestion(data) {
    return privateFetch.post(
      `/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions`,
      data
    );
  }

  function updateQuizQuestion(questionID, data) {
    return privateFetch.put(`/v1/admin/quiz/${quizID}/question/${questionID}`, data, configs);
  }

  function manageQuizQuestion(data = {}) {
    if (data?.id) {
      return updateQuizQuestion(data.id, data);
    }

    return addQuizQuestion(data);
  }

  return useMutation(manageQuizQuestion, {
    onSuccess() {
      // history.goBack();
    },
    onSettled() {
      // this will invalidate all queries starting with 'quiz'
      queryClient.invalidateQueries('quiz');
    },
  });
}

export default useManageQuizQuestion;
